import { createGlobalStyle, css } from 'themes';
import '../fonts/pretendard-subset.css';
// import GNB from '../../../coreSrc/core/js/components/GNB';

interface Props {
  isIOS?: boolean;
  isMobile?: boolean;
}
const GlobalStyleSheet = createGlobalStyle<Props>`
  html, body, #root {
    padding: 0;
    width : 100%;
    height: 100%;
    margin: 0;
  }
  img {
    line-height: 1;
  }

  body {
    ${p =>
      p.isIOS &&
      css`
        position: fixed;
        overflow: hidden;
      `};
    overscroll-behavior: contain;

  }
  #root {
    ${p =>
      p.isIOS &&
      css`
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
      `};
  }

  body.noscroll {
    overflow-y: hidden;
  }

  * {
    //font-family: "Noto Sans KR", sans-serif !important;
    font-family: 'Pretendard', sans-serif !important;
    //font-family: sans-serif !important;
    //position: relative;
    box-sizing: border-box;
    letter-spacing: -0.4px;
    user-select: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    outline: none;
  }

  input, textarea, *[contenteditable=true] {
    -webkit-user-select: auto;
    user-select: auto;
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
  }

  button {
    padding: 0;
    outline: none;
    border: 0;
    margin: 0;
    cursor: pointer;
  }
   
`;

export default GlobalStyleSheet;
